/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_No_Token_DetailInputs */

const en_pol_no_token_detail = /** @type {(inputs: Pol_No_Token_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription logins (Claude Pro/Max, ChatGPT Plus/Pro and the like) stay in the official agent on your own computer. Bystep's servers only keep API keys you paste yourself, encrypted.`)
};

const id_pol_no_token_detail = /** @type {(inputs: Pol_No_Token_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login langganan (Claude Pro/Max, ChatGPT Plus/Pro, dan sejenisnya) tetap di agen resmi di komputer kamu. Server Bystep hanya menyimpan kunci API yang kamu tempel sendiri, terenkripsi.`)
};

/**
* | output |
* | --- |
* | "Subscription logins (Claude Pro/Max, ChatGPT Plus/Pro and the like) stay in the official agent on your own computer. Bystep's servers only keep API keys you ..." |
*
* @param {Pol_No_Token_DetailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_no_token_detail = /** @type {((inputs?: Pol_No_Token_DetailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_No_Token_DetailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_no_token_detail(inputs)
	return en_pol_no_token_detail(inputs)
});